// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__bsIiQ","faq__wrap":"faq_faq__wrap__2H-Sf","join":"faq_join__3wgAL","join__img":"faq_join__img__NjJSX","join__btns":"faq_join__btns__3UALc"};